import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { useNotificationPreferences } from "@/react/components/Modals/MemberProfileModal/Notifications/useNotificationPreferences";
import { useCourseCustomLabels } from "@/react/components/Spaces/CourseSpace/Shared/useCourseCustomLabels";
import { drippedAtDateTime } from "@/react/helpers/courseHelpers";
import { dateStringToTimeAgo } from "@/react/helpers/dateTimeHelpers/timeAgo";
import type { CoursesLesson } from "@/react/types/CoursesLesson";
import { Typography } from "@circle-react-uikit/Typography";

interface LessonLockedProps {
  drippedAt: string;
  isDripped: boolean;
  lesson: CoursesLesson;
}
export const LessonLocked = ({
  isDripped,
  drippedAt,
  lesson,
}: LessonLockedProps) => {
  const { lessonLabel } = useCourseCustomLabels();
  const {
    get: { data: notificationPreferences },
  } = useNotificationPreferences();
  const isNewCourseContentNotificationEnabled = Boolean(
    notificationPreferences?.notification_types?.find(
      (item: any) => item.notification_type === "new_course_content",
    )?.values?.email,
  );
  return (
    <div
      className={classNames(
        "bg-secondary flex min-h-[16rem] flex-col items-center justify-center gap-2 p-4 text-center md:px-0 md:py-48",
        { hidden: isDripped },
      )}
      data-testid="lesson-content"
    >
      <div>
        <Typography.TitleMd as="h2">
          {lesson.needs_to_complete_previous_lesson || !drippedAt
            ? t(["courses.edit.lesson.locked_lesson", lessonLabel])
            : `${t("courses.edit.lesson.available")} ${dateStringToTimeAgo(
                drippedAt,
              )}`}
        </Typography.TitleMd>
      </div>
      <div>
        <Typography.LabelMd>
          {lesson.needs_to_complete_previous_lesson ? (
            t("courses.edit.lesson.unlock_by_completing", {
              all_previous_lessons: t([
                "courses.edit.lesson.unlock_by_completing_variables",
                "all_previous_lessons",
                lessonLabel,
              ]),
              this_lesson: t([
                "courses.edit.lesson.unlock_by_completing_variables",
                "this_lesson",
                lessonLabel,
              ]),
            })
          ) : !drippedAt ? (
            t("courses.edit.lesson.join_course_warning")
          ) : (
            <>
              {t("courses.edit.lesson.scheduled_availability_text", {
                this_lesson: t([
                  "courses.edit.lesson.scheduled_availability_text_variables",
                  "this_lesson",
                  lessonLabel,
                ]),
              })}{" "}
              <strong>{drippedAtDateTime(drippedAt)}</strong>
            </>
          )}
        </Typography.LabelMd>
      </div>
      {lesson.notify_students_enabled &&
        isNewCourseContentNotificationEnabled && (
          <Typography.LabelMd>
            {t("courses.edit.lesson.availability_text_2")}
          </Typography.LabelMd>
        )}
    </div>
  );
};
